<template>
    <validation class="form-group" :class="{ hasError: hasErrors, hasSuccess: isValid }"  :validator="v" :name="name" :inputclass="inputclass">
        <label v-if="label != ''">{{label}} <sup v-if="isRequired" class="text-danger">*</sup></label>
        <select2 v-model="data" :isLoading="isLoading" :options="options" :allowClear="allowClear"></select2>
        <div v-if="verr[0]" class="form-text errors text-danger">{{verr[0]}}</div>
    </validation>
</template>

<script>

import { singleErrorExtractorMixin } from "vuelidate-error-extractor";
import select2 from "./helpers/select2.vue";

export default {
    mixins: [singleErrorExtractorMixin],
    components: {
        select2
    },
    props: {
        value: {
            type: [String, Number],
            default: ""
        },
        name: {
            type: String,
            default: ""
        },
        options: {
            type: Array,
            default: ""
        },
        label: {
            type: String,
            default: ""
        },
        inputclass :{
            type: String,
            default: ""
        },
        placeholder: {
            type: String,
            default: ""
        },
        v: {
            type: Object,
            required: true
        },
        isLoading : {
            type: Boolean,
            default: false
        },
        verr : {
            type: Array,
            default: []
        },
        isRequired : {
            type: Boolean,
            default: false
        },
        allowClear : {
            type: Boolean,
            default: true
        }
    },
    watch: {
        isLoading (value, old) {

        },
    },
    mounted () {
        this.initialize();
    },
    computed: {
        data: {
            get() {
                return this.value;
            },
            set(value) {
                this.v.$touch();
                this.$emit("input", value);
            }
        }
    },
    methods : {
        initialize(){
        },
    }
};
</script>